/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Risks_OverviewInputs */

const en_footer_risks_overview = /** @type {(inputs: Footer_Risks_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risks overview`)
};

/**
* | output |
* | --- |
* | "Risks overview" |
*
* @param {Footer_Risks_OverviewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_risks_overview = /** @type {((inputs?: Footer_Risks_OverviewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Risks_OverviewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_risks_overview(inputs)
});